module.exports = __webpack_public_path__ + "static/media/karma.ae2dc13d.svg";